import { render, staticRenderFns } from "./DetailTopPart.vue?vue&type=template&id=1e151c4a&scoped=true&"
import script from "./DetailTopPart.vue?vue&type=script&lang=js&"
export * from "./DetailTopPart.vue?vue&type=script&lang=js&"
import style0 from "./DetailTopPart.vue?vue&type=style&index=0&id=1e151c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e151c4a",
  null
  
)

export default component.exports